import { DS_DRAGGING_BOUNDRY_ID, getMaxZIndex } from '@carboncopyco/utils';

export function customDraggingBoundry(remove?: boolean): void {
  const boundry = document.getElementById(DS_DRAGGING_BOUNDRY_ID);

  if (remove) {
    if (boundry) {
      boundry.remove();
    }
    return;
  }
  if (boundry) {
    return;
  }

  const div = document.createElement('div');
  div.id = DS_DRAGGING_BOUNDRY_ID;
  Object.assign(div.style, {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    zIndex: getMaxZIndex() + 1,
    pointerEvents: 'none',
    background: 'transparent',
  });

  document.body.appendChild(div);
}
